// Generated by scripts/generate-product-image-manifest.js.
export const productImageMap = {
  "100 Python Automation Scripts": {
    "main-photo": [
      "/images/products/100%20Python%20Automation%20Scripts/main-photo/Screenshot%202026-09-19%20at%209.41.18%E2%80%AFPM.png"
    ],
    "supporting-image-1": [
      "/images/products/100%20Python%20Automation%20Scripts/supporting-image-1/Screenshot%202026-09-19%20at%209.48.26%E2%80%AFPM.png"
    ],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "700+ Python Automation Tools": {
    "main-photo": [
      "/images/products/700%2B%20Python%20Automation%20Tools/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Advanced Cybersecurity SOC concepts": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "AI & Machine Learning Handbooks": {
    "main-photo": [
      "/images/products/AI%20%26%20Machine%20Learning%20Handbooks/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Analytics Dashboard Template": {
    "main-photo": [
      "/images/products/Analytics%20Dashboard%20Template/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Budget Plan Templates": {
    "main-photo": [
      "/images/products/Budget%20Plan%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Business Analytics Dashboard": {
    "main-photo": [
      "/images/products/Business%20Analytics%20Dashboard/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Business Articles of Incorporation templates": {
    "main-photo": [
      "/images/products/Business%20Articles%20of%20Incorporation%20templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Business Client Onboarding Templates": {
    "main-photo": [
      "/images/products/Business%20Client%20Onboarding%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Business Model Templates": {
    "main-photo": [
      "/images/products/Business%20Model%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Business Plan Templates": {
    "main-photo": [
      "/images/products/Business%20Plan%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Business Strategy Handbooks": {
    "main-photo": [
      "/images/products/Business%20Strategy%20Handbooks/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Company Deck Templates": {
    "main-photo": [
      "/images/products/Company%20Deck%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Company Profile Templates": {
    "main-photo": [
      "/images/products/Company%20Profile%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Contracts & Agreements Templates": {
    "main-photo": [
      "/images/products/Contracts%20%26%20Agreements%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "cyber-security-books": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Hacker's Library Bundle": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Cybersecurity Shortlisted Resumes": {
    "main-photo": [
      "/images/products/Cybersecurity%20Shortlisted%20Resumes/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "cybersecurity-free-tutorials": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Datasets": {
    "main-photo": [
      "/images/products/Datasets/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "DevOps Autoimation Scripts": {
    "main-photo": [
      "/images/products/DevOps%20Autoimation%20Scripts/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Employee Handbook": {
    "main-photo": [
      "/images/products/Employee%20Handbook/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Employment Agreement Templates": {
    "main-photo": [
      "/images/products/Employment%20Agreement%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "ESP8266 Scripts and Exploits": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Expense Report Templates": {
    "main-photo": [
      "/images/products/Expense%20Report%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Independent Contractor Agreement Templates": {
    "main-photo": [
      "/images/products/Independent%20Contractor%20Agreement%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Investment Proposal Templates": {
    "main-photo": [
      "/images/products/Investment%20Proposal%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Linux-Tools": {
    "main-photo": [
      "/images/products/Linux-Tools/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Marketing Plan Templates": {
    "main-photo": [
      "/images/products/Marketing%20Plan%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Non-Disclosure Agreement Templates": {
    "main-photo": [
      "/images/products/Non-Disclosure%20Agreement%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Offer Letter Templates": {
    "main-photo": [
      "/images/products/Offer%20Letter%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "OSCP Study Material": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Presentation templates": {
    "main-photo": [
      "/images/products/Presentation%20templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Printable Study Planners": {
    "main-photo": [
      "/images/products/Printable%20Study%20Planners/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Privacy Policy Templates": {
    "main-photo": [
      "/images/products/Privacy%20Policy%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Python API Testing Tools": {
    "main-photo": [
      "/images/products/Python%20API%20Testing%20Tools/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Python Resume Parser Tool": {
    "main-photo": [
      "/images/products/Python%20Resume%20Parser%20Tool/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Python-for-Security-and-Networking": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Royality Free Music": {
    "main-photo": [
      "/images/products/Royality%20Free%20Music/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Sales Proposal Template": {
    "main-photo": [
      "/images/products/Sales%20Proposal%20Template/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Security Blue Team Study Material": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "SEO Audit Checklist Templates": {
    "main-photo": [
      "/images/products/SEO%20Audit%20Checklist%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Social Media Strategy Documents": {
    "main-photo": [
      "/images/products/Social%20Media%20Strategy%20Documents/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Software resumes Templates": {
    "main-photo": [
      "/images/products/Software%20resumes%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Steganography": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Terms & Conditions Templates": {
    "main-photo": [
      "/images/products/Terms%20%26%20Conditions%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Website Elements": {
    "main-photo": [
      "/images/products/Website%20Elements/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Website Templates": {
    "main-photo": [
      "/images/products/Website%20Templates/main-photo/image.webp"
    ],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Windows Hacking Tools": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  },
  "Windows exploits": {
    "main-photo": [],
    "supporting-image-1": [],
    "supporting-image-2": [],
    "supporting-image-3": [],
    "supporting-image-4": [],
    "supporting-image-5": []
  }
};
